import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import {
  IPayerEngagementResponse,
  IPayerResponse
} from "@wingspanhq/payments/dist/interfaces";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import { useHistory } from "react-router-dom";
import { useQueryInvoice } from "../../../query/payments/queries";
import { DataView } from "../../../shared/components/DataView";
import { getPayerDetailsUrl } from "../../Payers/paths";
import { getPayerName } from "../../Payers/utils/getPayerNames";
import { getWorkLogPayeeStatusCellProps } from "../utils/getWorkLogPayeeStatusCellProps";
import styles from "./WorkLogAssignmentInfo.module.scss";

type Props = {
  shimmer?: boolean;
  workLog?: WorkLog;
  payer?: IPayerResponse;
  payerPayeeEngagement?: IPayerEngagementResponse;
};

export const WorkLogAssignmentInfoPayeeView: React.FC<Props> = props => {
  const history = useHistory();

  // TODO(v3): `invoiceId` renamed to `convertedResourceId` on v3 WorkLog.
  const queryInvoice = useQueryInvoice(props.workLog?.convertedResourceId!, {
    enabled: !!props.workLog?.convertedResourceId
  });

  const statusCellProps = props.workLog
    ? getWorkLogPayeeStatusCellProps({
        workLog: props.workLog,
        invoice: queryInvoice.data
      })
    : undefined;

  const name = props.payer ? getPayerName(props.payer) : undefined;
  const payerId = props.payer?.payerId;

  return (
    <WSElement>
      <WSSectionToolbar title="Assignment information" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Engagement name",
            value: props.payerPayeeEngagement?.engagementName
          },
          {
            label: "Status",
            secondaryText:
              statusCellProps?.text || statusCellProps?.secondaryText,
            secondaryTextColor: statusCellProps?.secondaryTextColor,
            pill: statusCellProps?.pill,
            hideValue: true
          },
          {
            label: "Client name",
            value: name && payerId ? "" : name,
            action:
              name && payerId
                ? {
                    label: name,
                    onClick: () => history.push(getPayerDetailsUrl(payerId)),
                    className: styles.entityLink
                  }
                : undefined
          }
        ]}
      />
    </WSElement>
  );
};
